/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    Backdrop, Button, CircularProgress, IconButton, Modal, withStyles,
} from '@material-ui/core';
import { func, object, bool } from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalHeading: {
        fontWeight: 900,
    },
    modalButtonContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        marginTop: '50px',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    modalCloseButton: {
        fontSize: '14px',
        borderRadius: '100px',
        color: 'white',
        backgroundColor: 'rgba(161, 0, 26, 1)',
        border: '2px solid rgba(161, 0, 26, 1)',
        margin: '5px',

        '&:hover': {
            backgroundColor: 'rgba(179, 44, 44, 1)',
            color: 'white',
            border: '2px solid rgba(179, 44, 44, 1)',
        },
        '@media screen and (max-width: 380px)': {
            fontSize: '10px',
        },
    },
    cancelBtn: {
        fontSize: '14px',
        borderRadius: '100px',
        color: 'black',
        border: '2px solid black',
        margin: '5px',

        '&:hover': {
            backgroundColor: 'black',
            border: '2px solid black',
            color: 'white',
        },
        '@media screen and (max-width: 380px)': {
            fontSize: '10px',
        },
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        outline: 'none',
        maxWidth: '550px',
        width: '90%',
        borderRadius: '10px',
    },
    paperContent: {
        padding: theme.spacing(2, 4, 3),
    },
    closeBtnContainer: {
        width: '100%',
        textAlign: 'end',
    },
    closeIconLabel: {
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
    errorMsg: {
        fontWeight: 900,
        color: 'red',
        textAlign: 'center',
        marginTop: '50px',
        padding: '10px',
        border: '1px solid red',
        borderRadius: '20px',
    },
    '@keyframes stroke': {
        '100%': {
            strokeDashoffset: '0',
        },
    },
    '@keyframes scale': {
        '0%, 100%': {
            transform: 'none',
        },
        '50%': {
            transform: 'scale3d(1.1, 1.1, 1)',
        },
    },
    '@keyframes fill': {
        '100%': {
            boxShadow: `inset 0px 0px 0px 40px ${theme?.palette?.primaryButton}`,
        },
    },
    checkmarkCircle: {
        strokeDasharray: '166',
        strokeDashoffset: '166',
        strokeWidth: '2',
        strokeMiterlimit: '10',
        stroke: theme?.palette?.primaryButton,
        fill: 'none',
        animation: '$stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards',
    },
    checkmark: {
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        display: 'inline-block',
        strokeWidth: 4,
        stroke: theme?.palette?.white,
        strokeMiterlimit: '10',
        margin: '14px 5px 14px 0',
        verticalAlign: 'middle',
        boxShadow: `inset 0px 0px 0px ${theme?.palette?.primaryButton}`,
        animation: '$fill .4s ease-in-out .4s forwards, $scale .3s ease-in-out .9s both',
    },
    checkmarkCheck: {
        transformOrigin: '50% 50%',
        strokeDasharray: '38',
        strokeDashoffset: '5',
        animation: '$stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards',
    },
    checkBoxContainer: {
        textAlign: 'center',
    },
});
const CancelSubscriptionModal = ({
    classes, close, open, cancelPassportMembership, cancelPassportMembershipError, cancelPassportMembershipSuccess, isLoading,
}) => (
    <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={close}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
            timeout: 500,
        }}
    >
        <div className={classes.paper}>
            <div className={classes.closeBtnContainer}>
                <IconButton
                    aria-label="delete"
                    align="right"
                    data-test="checkout-recipient-form-close"
                    data-testid="checkout-recipient-form-close"
                    id="recipientFormCloseLink"
                    classes={{
                        label: classes.closeIconLabel,
                    }}
                    onClick={close}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </div>
            <div className={classes.paperContent}>
                <p className={classes.modalHeading}>Are you sure you would like to cancel ?</p>
                <p>By canceling now, your Celebrations Passport Free Shipping/No Service Charge benefits, and any rewards points earned will expire immediately.</p>
                <p>Please call 1-800-961-2036 to speak with a customer service representative regarding any type of refund or any other questions regarding your membership before canceling.</p>
                {cancelPassportMembershipError && <div className={classes.errorMsg}>There was an error while canceling your passport membership. Please contact our customer service at <span style={{ display: 'inline-block' }}>1-800-961-2036.</span></div>}
                {cancelPassportMembershipSuccess ? (
                    <div className={classes.checkBoxContainer}>
                        <svg
                            className={classes.checkmark}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 52 52"
                        >
                            <circle className={classes.checkmarkCircle} cx="26" cy="26" r="25" fill="none" />
                            <path className={classes.checkmarkCheck} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                        </svg>
                    </div>
                ) : (
                    <>
                        {isLoading ? <div className={classes.checkBoxContainer}><CircularProgress size={24} /></div>
                            : (
                                <div className={classes.modalButtonContainer}>
                                    <Button variant="outlined" color="primary" className={classes.cancelBtn} onClick={cancelPassportMembership}>
                                        Yes, Cancel
                                    </Button>
                                    <Button variant="contained" color="primary" className={classes.modalCloseButton}  onClick={close}>
                                        No, I’d Like to Keep My Benefits
                                    </Button>
                                </div>
                            )}
                    </>
                )}
            </div>
        </div>
    </Modal>
);

CancelSubscriptionModal.propTypes = {
    classes: object,
    close: func,
    open: bool,
    isLoading: bool.isRequired,
    cancelPassportMembership: func.isRequired,
    cancelPassportMembershipError: bool.isRequired,
    cancelPassportMembershipSuccess: bool.isRequired,
};

CancelSubscriptionModal.defaultProps = {
    classes: {},
    close: () => { },
    open: false,
};

export default withStyles(styles)(CancelSubscriptionModal);
